module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"siteTitle":"Download Report"},"de":{"siteTitle":"Report herunterladen"},"fr":{"siteTitle":"Téléchargez le rapport"},"it":{"siteTitle":"Scarica rapporto"}}')
  delete Component.options._Ctor
}
